import { IconProps } from "./";
import Icon from "./assets/flame_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Flame(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
